import React from 'react'
import styled from 'styled-components'
import { Character } from './Character'
import { ImageField, TextField } from '@sentecacommerce-theme/base'
import { Heading, Carousel } from '../Common'

export type ShopByCharactersProps = {
  data: CharacterType[]
  labels: {
    findYourFavChar: TextField
  }
}

export type CharacterType = {
  header: TextField
  url: TextField
  image: ImageField
}

export const ShopByCharacters = ({ data, labels }: ShopByCharactersProps) => {
  return (
    <Container>
      <Heading data={labels?.findYourFavChar} />
      <CarouselContainer>
        <Carousel
          slides={data}
          renderSlide={(item: CharacterType) => (
            <Character
              key={`Character__${item.url}__${item.header}`}
              data={item}
            />
          )}
        />
      </CarouselContainer>
    </Container>
  )
}
const Container = styled.div.attrs({
  className: 'container',
})``

const CarouselContainer = styled.div`
  margin-top: -3rem;
`
